import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import {
  Box,
  Button,
  Divider,
  FormControl,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

import ContentContainer from '~/components/atoms/content-container/ContentContainer';
import { COLORS } from '~/styles/colors';

import PaymentsImages from './PaymentsImages';

type SummaryProps = {
  plan: number;
};

export default function Summary({ plan }: SummaryProps) {
  const { t } = useTranslation();
  const [currency, setCurrency] = useState('EUR');

  const handleChangeCurrency = (event) => {
    setCurrency(event.target.value);
  };

  return (
    <ContentContainer
      display="flex"
      justifyContent="space-between"
      resetPadding
      title={' '}
      containerStyles={{ margin: 0, flex: 1 }}
    >
      <Box display="flex" flex={1} flexDirection="column" m={3}>
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1}>
          <Typography fontSize={24}>{t('checkout:summaryTitle')}</Typography>
          <Box display="flex" alignItems="center">
            <FormControl>
              <Select sx={{ height: 40 }} value={currency} onChange={handleChangeCurrency} displayEmpty>
                <MenuItem value="USD">USD</MenuItem>
                <MenuItem value="EUR">EUR</MenuItem>
                <MenuItem value="PLN">PLN</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" flex={1} justifyContent="space-between" mt={6} mb={3}>
          <Typography fontSize={20} sx={{ color: COLORS.black06 }}>
            {plan} {t('checkout:period')}
          </Typography>
          <Typography fontSize={20} sx={{ color: COLORS.black06 }}>{`239,88 ${currency}`}</Typography>
        </Box>
        <Divider />
        <Box display="flex" flexDirection="row" flex={1} justifyContent="space-between" mt={3}>
          <Typography fontSize={20}>{t('checkout:total')}</Typography>
          <Typography fontSize={20}>{`239,88 ${currency}`}</Typography>
        </Box>

        <List
          display="flex"
          flexDirection="row"
          flex={1}
          justifyContent="space-between"
          sx={{ mt: 3, border: `1px solid ${COLORS.primaryGray}`, borderRadius: 1 }}
        >
          {[...Array(4)].map((_, index) => (
            <ListItem key={t(`checkout:summayList:a${index + 1}`)} sx={{ margin: 1 }}>
              <ListItemIcon>
                <CheckCircleIcon sx={{ fill: COLORS.black }} />
              </ListItemIcon>
              <ListItemText primary={t(`checkout:summayList:a${index + 1}`)} />
            </ListItem>
          ))}
        </List>

        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={1} mt={4}>
          <Typography display="flex" alignItems="center" color={COLORS.black06} textAlign="center">
            <LockIcon />
            {t('checkout:paymentSecure')}
          </Typography>
          <Typography mt={3} color={COLORS.black06}>
            {t('checkout:paymentMethods')}
          </Typography>
          <Box mt={2} mb={6}>
            <PaymentsImages />
          </Box>
          <Button sx={{ width: '100%', color: COLORS.purple }} variant="outlined">
            {t('checkout:cancelBtn')}
          </Button>
        </Box>
      </Box>
    </ContentContainer>
  );
}
